import { Header, HeaderContainer } from "./styles";
// Components
import Translations from "../../translations";
import ProjectVersion from "../../projectVersion";

const LoginHeader = () => (
  <Header>
    <HeaderContainer>
      <Translations />
      <ProjectVersion />
    </HeaderContainer>
  </Header>
);

export default LoginHeader;
